import React from 'react';
import { Row, Col } from 'antd';

import Header from '../Header';
import Footer from './Footer';
import style from './ComplianceClassification.module.scss';

export default function ComplianceClassification() {
  return (
    <>
      <Header />
      <main className="typography">
        <section className={style.heroSection}>
          <div className={style.heroBgMobile}>
            <div className="container">
              <h1 className="info-title underline">
                Compliance & Classification
              </h1>
            </div>
          </div>
          <div className="container">
            <div className={style.heroText}>
              <div className="info-subtitle underline"></div>
              <p>
                With a globalizing world and the need for critical skill sets
                comes the changing makeup of the worker population. The Gig
                Economy has taken full force, leading to vast changes for
                employers and employees.
              </p>
              <p>
                Regulatory agencies are evolving just as quickly, ensuring that
                all workers are properly classified and investing in more
                advanced ways to identify non-compliant practices.
              </p>
              <p>
                myBasePay is acutely sensitive to successfully managing the
                external workforce with proper oversight and compliance in a
                quickly shifting landscape.
              </p>
            </div>
            <h3 className="info-subtitle underline">
              We are a team of Human Capital experts who understand that getting
              the right talent at the right time with the right skill sets
              usually involves multiple parties. White Collar workers come in a
              mix of engagement types. Our solution recognizes the distinct
              compliance fulfillment needs of each one:
            </h3>
            <ul className="default-list rectangle">
              <li>W2 Workers | Employees</li>
              <li>1099 Workers | Independent Contractors</li>
              <li>Sub-Contractors | 3rd Party Staff Augmentations</li>
            </ul>
          </div>
        </section>
        <section className={style.infoSection}>
          <div className="container">
            <h3 className="info-subtitle underline">
              The Best of Both Worlds...No Regulatory Oversight, All Talent
              Management
            </h3>
            <Row gutter={[40, 40]}>
              <Col xs={24} sm={12} xl={9} className="d-flex">
                <div className="feature-card arrow right">
                  <div className="feature-text">
                    Outsource the entire employment engagement process
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} xl={9} className="d-flex">
                <div className="feature-card arrow bottom">
                  <div className="feature-text">
                    Minimize liability of overseeing a compliant external
                    workforce
                  </div>
                </div>
              </Col>
            </Row>
            <Row gutter={[40, 40]} justify="end">
              <Col xs={24} sm={12} xl={9} className="d-flex">
                <div className="feature-card arrow bottom-r">
                  <div className="feature-text">
                    Automate onboarding and pre-screening deployment initiations
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} xl={9} className="d-flex">
                <div className="feature-card arrow left">
                  <div className="feature-text">
                    Manage headcount and worker logistics through a convenient
                    portal
                  </div>
                </div>
              </Col>
            </Row>
            <Row gutter={[40, 40]}>
              <Col xs={24} sm={12} xl={9} className="d-flex">
                <div className="feature-card arrow right">
                  <div className="feature-text">
                    Customized approach with multi pay cycle capabilities and
                    oversight of any 3rd party
                  </div>
                </div>
              </Col>
              <Col xs={24} sm={12} xl={9} className="d-flex">
                <div className="feature-card arrow bottom">
                  <div className="feature-text">
                    Compliant practices like tax withholdings, robust risk
                    insurance extensions and year-end tax documentation
                  </div>
                </div>
              </Col>
            </Row>
            <Row gutter={[40, 40]} justify="end">
              <Col xs={24} sm={12} xl={9} className="d-flex">
                <div className="feature-card">
                  <div className="feature-text">
                    Curate quality talent with myBasePay’s Health Insurance
                    Subsidies and PTO Packages
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </section>
        <section className={style.tableSection}>
          <div className="container">
            <div className="table-main">
              <table>
                <thead>
                  <tr>
                    <th>Professional W2 Workers</th>
                    <th>Independent Contractor Workers</th>
                    <th>Sub-Contractor Workers</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Compliant Screening Measures</td>
                    <td>Proprietary streamlined classification process</td>
                    <td>Ensure Compliant VISA Status of all workers</td>
                  </tr>
                  <tr>
                    <td>Timely Onboarding and Payroll Processing</td>
                    <td>
                      Options to help independent contractors get the right
                      business insurance
                    </td>
                    <td>Protocols to support VISA renewals fulfillment</td>
                  </tr>
                  <tr>
                    <td>Tax Withholdings and Deposits</td>
                    <td>Health Insurance Plans with broker network special</td>
                    <td>Vetting of compliant representative sponsorship</td>
                  </tr>
                  <tr>
                    <td>Insurance Coverage for Assigned Employees</td>
                    <td>Weekly Pay Disbursements to all Worker Types</td>
                    <td>Talent Pools to leverage in the marketplace</td>
                  </tr>
                  <tr>
                    <td>Paid Time Off Eligibility for ALL Full-Time Workers</td>
                    <td>
                      Invoice & Timecard Management with billing transparency
                    </td>
                    <td>
                      Assurance of proper insurance fulfillments for ACA
                      Compliance and Risk Policies
                    </td>
                  </tr>
                  <tr>
                    <td>Administration of Employee Health Benefits</td>
                    <td>
                      Audit-Ready compliance and regulatory responsibility
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
